import service from './http'
import serve from "@/utils/serve";
import Workflow from "@/types/Workflow";

class WorkflowService {
    async add({systemAlias}: { systemAlias: string }, workflow: Workflow) {
        return await serve(async () => await service.post(`systems/${systemAlias}/workflows`, workflow))
    }

    async get({systemAlias, workflowAlias}: {systemAlias: string, workflowAlias: string}) {
        return await serve(async () => await service.get(`systems/${systemAlias}/workflows/${workflowAlias}`))
    }

    async update({systemAlias, workflowAlias}: { systemAlias: string, workflowAlias: string }, patch: Partial<Workflow>) {
        return await serve(async () => await service.patch(`systems/${systemAlias}/workflows/${workflowAlias}`, patch))
    }

    async list({systemAlias}: { systemAlias: string }) {
        return await serve(async () => await service.get(`systems/${systemAlias}/workflows`))
    }

    async delete({systemAlias, workflowAlias}: {systemAlias: string, workflowAlias: string}) {
        return await serve(async () => await service.delete(`systems/${systemAlias}/workflows/${workflowAlias}`))
    }
}

export default WorkflowService